<template>
  <div class="sidebar-wrapper">
    <nav id="sidebar">
      <div class="sidebar-content">
         <SidebarSearch :maxlength="30" />
        <div class="sidebar-menu mt-2">
          <div role="tablist" v-if="itens != null">
            <Item :menu="item" v-for="item in itens" :key="item.name" />
          </div>
        </div>
        <!-- sidebar-menu  -->
      </div>
      <!-- sidebar-content  -->
    </nav>
  </div>
</template>

<script>
import menu from '@/api/menu'
import Item from './Item'
import SidebarSearch from '@/layout/components/sidebar-menu/SidebarSearch'
export default {
  components: { Item, SidebarSearch },
  data () {
    return {
      itens: []
    }
  },
  computed: {
    // itens () {
    //   return this.$store.getters.getMenu
    // }
  },
    methods: {
      adicionarChildren(el, userData) {
          if (el.children !== undefined && el.children.length > 0) {
              let childrenTemp = [];
              el.children.forEach(ch => {
                  if (userData.groups) {
                      let permissionCh = false,
                          groupNameCh = '';
                      for (let i = 0; i < userData.groups.length; i++) {
                          groupNameCh = userData.groups[i];
                          if (ch.groups.indexOf(groupNameCh) != -1) {
                              permissionCh = true;
                              break;
                          }
                      }

                      if (permissionCh) {
                          this.adicionarChildren(ch, userData);
                          childrenTemp.push(ch);
                      }
                  }
              });

              el.children = childrenTemp;
          }
      }
    },
    mounted() {
        let temp = [];

        menu.itens.forEach(el => {
            let userData = JSON.parse(this.$store.getters.getUser);
            if (userData.groups) {
                let permission = false,
                    groupName = '';
                for (let i = 0; i < userData.groups.length; i++) {
                    groupName = userData.groups[i];
                    if (el.groups.indexOf(groupName) != -1) {
                        permission = true;
                        break;
                    }
                }

                if (permission) {
                    this.adicionarChildren(el, userData);

                    temp.push(el);
                }
            }
        });

        this.itens = temp;
    }
}
</script>

<style>
</style>
